<section class="request-body">
  @if(relogin()){
    <p class="m-0">
      Please enter your phone number to login.
    </p>
  } @else {
    <p class="m-0">
      Login or create a free account to start benefiting today!
    </p>
  }
  <form class="phone-form" [formGroup]="form" (ngSubmit)="requestVerification()">
    <div class="phone-input">
      <lib-country-list [preferredCountryCodes]="['mt']" [selectedCountryCode]="'mt'" [countryListConfig]="{ hideCode: true }" [selectedCountryConfig]="{ hideCode: true, hideName: true }" (onCountryChange)="form.get('country_code')!.setValue($event.dialling_code)"></lib-country-list>
      <input class="ml-8" matInput type="tel" autocomplete="tel" inputmode="tel" formControlName="phone" placeholder="Mobile number">
    </div>
    @if(form.touched && form.get('phone')?.errors){
      @if(form.get('phone')?.hasError('required')){
        <mat-error>
          Phone is <strong>required</strong>.
        </mat-error>
      } @else {
        <mat-error>
          Phone is <strong>invalid</strong>.
        </mat-error>
      }
    } @else {
      <mat-hint>&nbsp;</mat-hint>
    }
    <br />
    <button mat-flat-button color="primary" rounded class="login-button" type="submit" [disabled]="loading()">
      <span class="font-semibold">{{loading() ? 'Loading...' : buttonText()}}</span>
    </button>
    <br />
    <br />
    <!-- <a color="primary" class="font-semibold" [routerLink]="[]">Employee benefit</a>
      <br/>
      <br/> -->
  </form>
</section>